import { CSSProperties } from 'react';

/**
 * Inline separator between card facts. Renders as: nbsp nbsp bullet nbsp nbsp
 * (U+00A0 x2, U+2022, U+00A0 x2) -- byte-identical to the old
 * `&nbsp;&nbsp;&bull;&nbsp;&nbsp;` literals, centralized so the spacing is defined once.
 */
export const BULLET = '\u00A0\u00A0\u2022\u00A0\u00A0';

/**
 * Single-line truncation style for a professional name. `maxWidth` differs per caller
 * (responsive on the name row, fixed on the legacy favorites card); everything else --
 * the ellipsis behavior (asserted by tests) and the unavailable dimming -- is shared.
 */
export const getTruncatedNameStyle = (
  maxWidth: CSSProperties['maxWidth'],
  isAvailable: boolean,
): CSSProperties => ({
  display: 'inline-block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  maxWidth,
  opacity: isAvailable ? 1 : 0.5,
});
